import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import UserTable from "../../Components/User/UserTable.js";
import { GET_USERS } from "../../GraphQL/Users";
import { LoginContext } from "../../Components/Login/LoginContext";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";

const UsersPage = () => {
  const users = useQuery(GET_USERS, {});
  const [auth] = useContext(LoginContext);

  if (users.error) {
    return (
      <PageError message={users.error.message} onRetry={() => users.refetch()} />
    );
  }

  if (users.loading) return <LoadingSpinner />;

  return (
    <PageLayout
      title="Users"
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Users" }]}
    >
      <UserTable users={users.data.users} showActions={auth.loggedIn} />
    </PageLayout>
  );
};

export default UsersPage;
